//export const MEAT_API ='http://192.168.1.42:3000';
export const MEAT_API ='http://webservice.integrasist.com.br';
//export const MEAT_API ='http://192.168.1.28:3000';
export const CHAVE_API = 'fbf2d329b558e6ce4a047cdIntegraWeB';


// WEBPACK FOOTER //
// ./src/app/app.api.ts